
//PC_PD_01, PC_PD_02 - for import and PolicyDirectoryComponent component creation
import { createContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPolicyDirectory } from '../service/todo';
import { getDomain } from '../service/DirectorAPI';
// import IndividualPolicyDirectory from './IndividualPolicyDirectory.jsx'; 
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import moment, { months } from 'moment';
import Loader from '../StaticComponent/Loader';
import BreadCrumbs from '../components/BreadCrumbs/BreadCrumbs.jsx';
import { getTimestampToDate } from '../utils/dateConvetor.js';
import DOMPurify from 'dompurify';

export const filterValue = createContext({});
export default function PolicyDirectoryComponent() {
    // PC_PD_05 to PC_PD_06 - directoryObj obj with key value pair
    let directoryObj = {
        domain: "",
        status: "",
        fromDate: "",
        toDate: "",
        search: "",
        sort: "b.emp_name",
        order: "ASC",
        limit: 10
    }


    // PC_PD_06 state variable declaration
    const [directoryData, setDirectoryData] = useState(directoryObj);
    const [pagination, setPagination] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [hideContainer, setHideContainer] = useState(true);
    let dropDownArraydomain = [];
    const [domainDropDown, setDomainDropDown] = useState(dropDownArraydomain);
    const [isLoading, setIsLoading] = useState(false); // by default it will trigger
    let navigate = useNavigate();
    const [clearFilter, setClearFilter] = useState(true);
    const [showMore, setShowMore] = useState(true);


    //  PC_PD_50 to  PC_PD_59 - sort in ascending and descending
    const [columnOrder, setColumnOrder] = useState('ASC');
    const [columnName, setColumnName] = useState('emp_name');
    const [sorthide, setsorthide] = useState('emp_name@ASC');

    // PC_PD_69 to  PC_PD_71 - for navigation and bread crumbs
    let breadCrumbsData =
        [
            { title: 'Dashboard', isActive: true, path: '/Overview' },
            { title: 'How Do I?', isActive: true, path: '' },
            { title: 'Policy Directory', isActive: false, path: '/PolicyDirectory' },
        ]

    useEffect(() => {
        policydirectorydetails();
    }, [directoryData.limit, sorthide, clearFilter, showMore]);

    useEffect(() => {
        domainName();
    },[])

    // PC_PD_06 to  PC_PD_08 - policydirectorydetails function creation
    // PC_D_39 - to setstate the result
    async function policydirectorydetails() {
        let result = await getPolicyDirectory(directoryData);
        setGridData(result[0]?.data)     
        setPagination(result[1]?.data[0]?.count)   
        setIsLoading(true); 
    }

    // const totalempCount= pagination[0].count
    const countonclickOfLoadMore =directoryData.limit


    // PC_PG_10 to  PC_PG_12 - format date
    function formatDate(date) {
        var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [month, day, year].join("/");
    }

    function nameSubstring(value) {
        var tipCount;
        if (value?.length > 21) {
            let data = value.substring(0, 21);
            data = data + '...';
            tipCount = 1;
            return data;
        } else {
            let data = value;
            tipCount = 0;

            return data;
        }
    }

    // PC_PD_65 to  PC_PD_68 - clear action in advance filter
    const filterclear = () => {
        setIsLoading(true)
        // 
        let cleardirectoryObj = {
            domain: '',
            status: '',
            fromDate: '',
            toDate: '',
            search: '',
            sort: 'b.emp_name',
            order: 'ASC',
            limit: 10
        }
        setClearFilter(!clearFilter);
        setDirectoryData(cleardirectoryObj);
        setHideContainer(true)
    }

    const filterCheck = (e) => {
        try {
            setHideContainer(hideContainer == true ? false : true)
        }
        catch (e) { }
    }


    //  PC_PD_43 to  PC_PD_49 - for search handling
    const handleSearch = (e) => {
        try {
            setDirectoryData({
                ...directoryData,
                ["search"]: e.target.value
            })
        } catch (e) { }
    };


    const handleSearchKeyDown = (e) => {
        // 
        if (e.key === "Enter") {
            setIsLoading(true)
            setDirectoryData({
                ...directoryData,
                "limit": 10
            });
            setShowMore(!showMore)
        }
    };

    const searchClick = () => {
        // 
        setIsLoading(true)
        setDirectoryData({
            ...directoryData,
            "limit": 10
        })
        setShowMore(!showMore)
    };

    const sortClicked = (e) => {
        try {

            let sortID = e.target.id;
            let sortval = sortID.split('@');
            setDirectoryData({ ...directoryData, sort: sortval[0], order: sortval[1] });
            setColumnName(sortval[0]);
            setColumnOrder(sortval[1]);
            setsorthide(sortID);
        } catch (e) { }
    };

    async function domainName() {
        let result = await getDomain();
        setDomainDropDown(result?.data?.ResponseData[0])
    }

    // PC_PD_73 to  PC_PD_86 - to export to excel
    const handleExportExcel = async () => {
        if (gridData?.length ) {
          try {
              let ExportToExcelArray = gridData?.map((item) => {
              return item;
            });
            let newexcel = XLSX.utils.book_new();
            let data = XLSX.utils.json_to_sheet(ExportToExcelArray);
            newexcel.SheetNames = ["Policy_Directory"];
            const policydirectory = XLSX.utils.json_to_sheet(ExportToExcelArray);
            policydirectory["A1"].s = {};
            newexcel.Sheets.Policy_Directory = policydirectory;
           
            XLSX.writeFile(newexcel, `PolicyDirectory_${moment().format('YYYY-MM-DD hh_mm_ss')}.xlsx`);
          } catch (e) {
            console.log("error", e.message);
          }
        }
    };

    //  PC_PD_20 to  PC_PD_22 - buind function
    function bindPolicyDirectory() {
        // const totalempCount= pagination
        if (gridData) {

            return gridData?.map((value, index) => {
                var empCharName = nameSubstring(value.emp_name);
                var empCharRole = nameSubstring(value.role);
                const phoneNoLink = `tel:${value.phone_num}`;
                const emailLink = `mailto:${value.email_id}`;
                return (

                    <tr>

                        <td className=" profile-det-popover curser-pointer">
                            <div className="d-flex align-items-center">
                                <a href={`/profilecontainer?EmpId=${value.emp_id}&Status=${value.status}`}>
                                    <img
                                        src={value.profile_img_url ? value.profile_img_url : '/Images/logo-person-user-person-icon.jpg'}
                                        className="table-image"
                                    />
                                </a>
                                <div className="ms-2">
                                    <a
                                        href={`/profilecontainer?EmpId=${value.emp_id}&Status=${value.status}`}
                                        className="directory-name-style mb-0 d-flex align-items-center semibold-text "
                                    >
                                        {value.emp_name ? empCharName : '-'}
                                        {/* {value.status == 'Inactive' ? (
                                                <>
                                                    <span>
                                                        <img
                                                            src="Images/inactive-batch.svg"
                                                            alt="inactive-batch"
                                                            className="ms-2 inact-bat-img"
                                                        />
                                                    </span>
                                                    <span className="font-9 inactive-txt-clr ms-1">Inactive</span>
                                                </>
                                            ) : (
                                                <></>
                                            )} */}
                                    </a>
                                    <p className="directory-domain-style mb-0">{value.role ? empCharRole : '-'}</p>
                                </div>
                            </div>
                            <div className="prof-det-crd shadow" >
                                <div className="row">
                                    <div className="d-flex align-item-center mb-4">
                                        <div className="d-block">
                                            <img
                                                src={
                                                    value.profile_img_url
                                                        ? value.profile_img_url
                                                        : '/Images/logo-person-user-person-icon.jpg'
                                                }
                                                className="emp-prof-popover"
                                            />
                                        </div>
                                        <div className="d-block ms-3">
                                            <h3 className="mb-1 font-17 bold-text">{value.emp_name}</h3>
                                            <p className="mb-0 font-12 regular-text">{value.role}</p>
                                            <p className="mb-0 font-12 regular-text">{value.domain}</p>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <span className="d-block mb-2 font-14">
                                            <span>
                                                <img src="Images/hive-mail-icon.svg" alt="hive-mail-icon" />
                                            </span>
                                            <a href={DOMPurify.sanitize(emailLink)} className="prof-link regular-text ms-3">
                                                <span>{value.email_id ? value.email_id : '-'}</span>
                                            </a>
                                        </span>
                                        <span className="d-block mb-2 font-14">
                                            <span>
                                                <img src="Images/hive-phn-icon.svg" alt="hive-phn-icon" />
                                            </span>
                                            <a href={DOMPurify.sanitize(phoneNoLink)} className="prof-link regular-text ms-3">
                                                <span>{value.phone_num ? value.phone_num : '-'}</span>
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>{value?.domain}</td>
                        <td>{value?.status}</td>
                        <td>{value?.email_id}</td>
                        <td>{value?.phone_num ? value?.phone_num : "-"}</td>
                        <td>{getTimestampToDate(value.joined_date, 3)}</td>
                        <td><span className="d-flex align-items-center gap-1"><img src="Images/Policy/ak-policy-doc-icon.svg" alt="ak-policy-doc-icon" />
                            <a href={`/individualpolicydetail?employeeId=${value.emp_id}&emplpoyeeName=${value.emp_name}`}
                                className="directory-link-clr">{value.acknowledgment_count}/{value.total_count}</a></span>
                        </td>
                    </tr>
                );
            });
        }
    };

    function bindDomain() {
        if (domainDropDown) {
            return domainDropDown?.map((value, index) => {
                return (
                    <option value={value?.domain}>{value?.domain}</option>)
            });
        }
    }


    //render
    return (
        <>
            {/* <filterValue.Provider value={{gridData}}>
 <IndividualPolicyDirectory/>
 </filterValue.Provider> */}
            <div className="container-fluid mt-5">
                <Loader isLoading={isLoading} />
                <div className="row">
                    <div className="col-md-11" style={{ marginTop: '10px' }}>
                        <BreadCrumbs data={breadCrumbsData} />
                    </div>
                    <div className="col-md-12">
                        <div className=" px-4">
                            <div className="col-md-11 d-flex justify-content-between my-4  align-items-center">
                                <h2 className="mb-0 heading-color bold-text font-18">Policy Directory </h2>
                                <div>
                                    <ul className="nav">
                                        <li>
                                            <div className="input-group flex-nowrap search-group me-2">
                                                <input type="search"
                                                    className="form-control search-align"
                                                    placeholder="Search"
                                                    aria-label="Username"
                                                    aria-describedby="addon-wrapping"
                                                    onChange={(e) => { handleSearch(e) }}
                                                    onKeyUp={(e) => { handleSearchKeyDown(e) }}
                                                    value={directoryData.search}
                                                />
                                                <button className="input-group-text btn btn-search-custom align-items-center d-flex" id="addon-wrapping"><img src="Images/Policy/todo-find-icon.svg" alt="search-icon" className="todo-find-icon"
                                                    onClick={() => { searchClick() }}
                                                /></button>
                                            </div>
                                        </li>
                                        <li>
                                            {/*Filter Section Starts Here*/}

                                            <div className="dropdown">
                                                <button
                                                    className="advanced-filter-button me-2 medium-text"
                                                    type="button"
                                                    id="feedback-filter-dropdown"
                                                    data-bs-toggle="dropdown"
                                                    onClick={() => filterCheck()}
                                                >
                                                    <img src="/Images/filter-icon.svg" className="me-2" />
                                                    Filter
                                                </button>
                                                {!hideContainer ?
                                                    (<div className="dropdown-menu px-3 advanced-filter-panel" style={{ display: 'block' }}>
                                                        {/* <div className="col-md-12"> */}
                                                        <div className="col-md-12 py-2 border-0 mb-1">
                                                            <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>

                                                            <button
                                                                type="button"
                                                                className="btn-close float-end close-filter"
                                                                data-bs-dismiss="advanced-filter"
                                                                aria-label="Close"
                                                                onClick={() => filterclear()}
                                                            />

                                                        </div>
                                                        <div className="col-md-12 ">
                                                            <div className="row mb-3">
                                                                <div className="col-md-6 mb-3">
                                                                    <label className="form-label hive-form-label" htmlFor="domain-status">Domain</label>
                                                                    <select
                                                                        className="form-select hive-form-control"
                                                                        id="domain"
                                                                        name="domain"
                                                                        onChange={(e) => { setDirectoryData({ ...directoryData, ["domain"]: e.target.value }) }}
                                                                        value={directoryData.domain}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        {bindDomain()}
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-6 mb-3">
                                                                    <div className="mb-3">
                                                                        <label className="form-label hive-form-label" htmlFor="status">Status</label>
                                                                        <select className="form-select hive-form-control" id="status" name="status"
                                                                            value={directoryData.status}

                                                                            onChange={(e) => { setDirectoryData({ ...directoryData, ["status"]: e.target.value }) }}
                                                                        >
                                                                            <option selected>Select</option>
                                                                            <option value="Active">Active</option>
                                                                            <option value="Inactive">Inactive</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-12 pb-2 border-0">
                                                                {/* <div className="mt-3"> */}
                                                                <span className="font-14 semibold-text filter-title"

                                                                >Joined Date</span>
                                                                {/* </div> */}
                                                            </div>
                                                            <div className="row mb-3">
                                                                <div className="col-md-6 mb-3">
                                                                    <label className="form-label hive-form-label" htmlFor="fromrange">
                                                                        From
                                                                    </label>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control hive-form-control"
                                                                        id="fromrange"
                                                                        name="startDate"
                                                                        value={directoryData.fromDate}
                                                                        max={directoryObj.toDate}
                                                                        onChange={(e) => { setDirectoryData({ ...directoryData, ["fromDate"]: e.target.value }) }} />

                                                                </div>
                                                                <div className="col-md-6 mb-3">
                                                                    <label className="form-label hive-form-label" htmlFor="torange">
                                                                        To
                                                                    </label>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control hive-form-control"
                                                                        id="torange"
                                                                        name="endDate"
                                                                        value={directoryData.toDate}
                                                                        min={directoryData.fromDate ? directoryData.fromDate : undefined}
                                                                        onChange={(e) => { setDirectoryData({ ...directoryData, ["toDate"]: e.target.value }) }} />
                                                                </div>
                                                            </div>
                                                            {/* <div className='=row mb-3'>
                                                        <div className="col-md-6 mb-3">
                                                            <div className="mb-3">
                                                            <label
                                                                    className="form-label hive-form-label"
                                                                    htmlFor="startFrom"
                                                                >From</label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control hive-form-control"
                                                                    id="startFrom"
                                                                    name="fromDate"
                                                                    // value={directoryObj.joinFromDate}
                                                                    value={directoryData.fromDate}
                                                                    max={directoryObj.toDate}
                                                                    onChange={(e) => { setDirectoryData({ ...directoryData, ["fromDate"]: e.target.value }) }} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <div className="mb-3">
                                                                <label className="form-label hive-form-label" htmlFor="torange">To</label>
                                                                <input type="date"
                                                                    className="form-control hive-form-control"
                                                                    id="startTo"
                                                                    name="toDate"
                                                                    value={directoryData.joinToDate}
                                                                    min={directoryData.fromDate ? directoryData.fromDate : undefined}
                                                                    onChange={(e) => { setDirectoryData({ ...directoryData, ["toDate"]: e.target.value }) }} />
                                                            </div>
                                                        </div>
                                                        </div> */}
                                                        </div>
                                                        <div>
                                                            <div className="text-end mt-4 mb-2">
                                                                <button type="button"
                                                                    className="btn cancel-button btn-link text-black shadow-none font-14 bold-text px-3 me-3"
                                                                    onClick={(e) => { filterclear() }}>
                                                                    Clear
                                                                </button>
                                                                <button type="button"
                                                                    className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                                    onClick={() => { setHideContainer(true); policydirectorydetails() }}>
                                                                    Apply
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {/* </div> */}
                                                    </div>) : null}
                                            </div>

                                            {/*Filter Section Ends Here*/}
                                        </li>
                                        <li>
                                            <button
                                                className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                type="button"
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                onClick={(e) => handleExportExcel(e)}
                                            >
                                                Export to Excel
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="table-responsive table-overflow-visible">
                                <table className="table bg-white hive-grid table-borderless">
                                    <thead className="hive-table-head">
                                        <tr>
                                            <th>Employee Name
                                                <span className="ms-2">
                                                    <img src="Images/Policy/sort-down.svg" alt="sort-down" className="cursor-pointer"
                                                        id="emp_name@DESC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'emp_name@DESC' ? true : false}
                                                    />
                                                    <img
                                                        src="Images/Policy/sort-up.svg"
                                                        className="hive-table-sort"
                                                        id="emp_name@ASC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'emp_name@DESC' ? false : true}
                                                    />
                                                </span>
                                            </th>
                                            <th>Domain
                                                <span className="ms-2">
                                                    <img src="Images/Policy/sort-down.svg" alt="sort-down" className="cursor-pointer"
                                                        id="domain@DESC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'domain@DESC' ? true : false}
                                                    />
                                                    <img
                                                        src="Images/Policy/sort-up.svg"
                                                        className="hive-table-sort"
                                                        id="domain@ASC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'domain@DESC' ? false : true}
                                                    />
                                                </span></th>
                                            <th>Status
                                                <span className="ms-2">
                                                    <img src="Images/Policy/sort-down.svg" alt="sort-down" className="cursor-pointer"
                                                        id="b.status@DESC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'b.status@DESC' ? true : false}
                                                    />
                                                    <img
                                                        src="Images/Policy/sort-up.svg"
                                                        className="hive-table-sort"
                                                        id="b.status@ASC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'b.status@DESC' ? false : true}
                                                    /></span></th>
                                            <th>Email ID</th>
                                            <th>Phone Number</th>
                                            <th>Joined Date
                                                <span className="ms-2">
                                                    <img src="Images/Policy/sort-down.svg" alt="sort-down" className="cursor-pointer"
                                                        id="b.joined_date@DESC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'b.joined_date@DESC' ? true : false}
                                                    />
                                                    <img
                                                        src="Images/Policy/sort-up.svg"
                                                        className="hive-table-sort"
                                                        id="b.joined_date@ASC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'b.joined_date@DESC' ? false : true}
                                                    /></span></th>
                                            <th>Ack Policy<span className="ms-2"></span></th>
                                        </tr>
                                    </thead>
                                    <tbody className="regular-text font-12">
                                        {
                                            bindPolicyDirectory()
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {pagination > gridData?.length ?
                                <div className="text-center mb-3">
                                    <button className="btn show-more-btn"
                                        onClick={(e) => {
                                            setIsLoading(false);
                                            setDirectoryData({
                                                ...directoryData,
                                                "limit": directoryData.limit + 10
                                            })
                                        }}>
                                        Show More
                                    </button>
                                </div> : <></>}
                            <p className="font-12 regular-text mt-2">Showing <span className="bold-text">{gridData?.length}</span> of {pagination}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}